<style src="./style.scss">

</style>

<article class="mbsc-row">
  <RelatedContent
    title="Nuestros instructores"
    followLink={true}
  ></RelatedContent>
</article>
<article class="mbsc-row">
  <Banner></Banner>
</article>

<script>
import { onMount, afterUpdate } from 'svelte';
import { AWSAuth, AWSAnalytics } from '@Services';

import Banner from '@Components/Banner/index.svelte';
import CategoryGrid from '@Components/CategoryGrid/index.svelte';
import ClassExplorer from '@Components/ClassExplorer/index.svelte';
import RelatedContent from '@Components/RelatedContent/index.svelte';
// Logged In members
import ClassPlayer from '@Components/ClassPlayer/index.svelte';

const DEBUG = document.location.protocol === 'http:' ? true : false;

let isVisitor = true;

onMount(async () =>{
  AWSAuth.isAnonymous().then(response => {
    if (response !== isVisitor) {
      isVisitor = response;
    }
  });
});
</script>
